export default __webpack_public_path__ + "static/media/Email Header.c1e1dc6a.png";